import TreeNodeInfo from "../../models/TreeNodeInfo";

/** Adapts the existing tree view models, including comparison rows, to navigator data. */
export function navigatorChildren(parent: TreeNodeInfo): readonly TreeNodeInfo[] {
  const view = parent.obj.treeViewModel;
  if (!view.isFolder) return [];
  const children = [...(view.getChildCollectionEx(parent) ?? [])];
  if (state.showModifiedStatus || globalThis.compareState) {
    for (const object of view.deletedChildCollection) children.push(new TreeNodeInfo(parent, object));
    for (const object of view.newInOtherChildCollection) children.push(new TreeNodeInfo(parent, object));
  }
  return children;
}
